import { gql } from '@apollo/client';

export const QUERY = gql`
  query GetProductPaywallConfiguration($productShortCode: String) {
    getProductPaywallConfiguration(productShortCode: $productShortCode) {
      productIds
      productShortCodes
      companyId
      configuration
      _lastModifiedBy
      _id
      createdAt
      updatedAt
    }
  }
`;
